package ru.dinarastepina.fabvocab.contracts

import ru.dinarastepina.fabvocab.domain.model.Exercise
import ru.dinarastepina.fabvocab.domain.model.WordEntry
import ru.dinarastepina.fabvocab.domain.model.WordStats

fun WordEntry.toDto(): WordEntryDto = WordEntryDto(
    id = id,
    word = word,
    phonetic = phonetic,
    audioUrl = audioUrl,
    partOfSpeech = partOfSpeech,
    definitions = definitions,
    exampleSentences = exampleSentences,
    addedAt = addedAt,
    updatedAt = updatedAt,
    isDeleted = isDeleted,
)

fun WordEntryDto.toDomain(): WordEntry = WordEntry(
    id = id,
    word = word,
    phonetic = phonetic,
    audioUrl = audioUrl,
    partOfSpeech = partOfSpeech,
    definitions = definitions,
    exampleSentences = exampleSentences,
    addedAt = addedAt,
    updatedAt = updatedAt,
    isDeleted = isDeleted,
)

fun WordStats.toDto(): WordStatsDto = WordStatsDto(
    wordId = wordId,
    attempts = totalAnswers,
    correct = correctAnswers,
    accuracyPercent = if (totalAnswers == 0) 0 else (correctAnswers * 100 / totalAnswers),
)

fun Exercise.toDto(): ExerciseDto = when (this) {
    is Exercise.FillBlank -> ExerciseDto.FillBlankDto(
        wordId = wordId,
        sentence = sentence,
        answer = answer,
        hint = hint,
    )
    is Exercise.DefinitionMatch -> ExerciseDto.DefinitionMatchDto(
        wordId = wordId,
        word = word,
        options = options,
        correctIndex = correctIndex,
    )
    is Exercise.TrueFalse -> ExerciseDto.TrueFalseDto(
        wordId = wordId,
        sentence = sentence,
        isCorrectUsage = isCorrectUsage,
        explanation = explanation,
    )
}

fun ExerciseDto.toDomain(): Exercise = when (this) {
    is ExerciseDto.FillBlankDto -> Exercise.FillBlank(
        wordId = wordId,
        sentence = sentence,
        answer = answer,
        hint = hint,
    )
    is ExerciseDto.DefinitionMatchDto -> Exercise.DefinitionMatch(
        wordId = wordId,
        word = word,
        options = options,
        correctIndex = correctIndex,
    )
    is ExerciseDto.TrueFalseDto -> Exercise.TrueFalse(
        wordId = wordId,
        sentence = sentence,
        isCorrectUsage = isCorrectUsage,
        explanation = explanation,
    )
}
